const API_URL = 'https://api.shopali.re/api'; 
//const API_URL = 'http://localhost:5000/api'; 

export const itemService = {
    login: (credentials) => fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials)
    }),

    registerAdmin: (data) => fetch(`${API_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }),

    joinFamily: (data) => fetch(`${API_URL}/auth/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }),

    getHouseholdInfo: async (hId) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/households/${hId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.json();
    },

    syncItems: async (items, householdId, token) => {
        return fetch(`${API_URL}/items/sync`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ items, household_id: householdId })
        });
    },

    fetchItems: async (token) => {
        return fetch(`${API_URL}/items`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
    }
};